import { Box, Card, CardMedia, Grid } from '@mui/material'
import { memo, useMemo, useRef, useState } from 'react'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import Icon from '../../../../../../components/icon'
import './GazeImageSwiper.scss'

const GazeImageSwiper = ({ images, onImageClick }) => {
  const swiperRef = useRef(null)
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  // Chunk images into groups of 10 (2 rows x 5 columns)
  const imageChunks = useMemo(() => {
    const chunks = []
    for (let i = 0; i < images.length; i += 10) {
      chunks.push(images.slice(i, i + 10))
    }
    return chunks
  }, [images])

  if (!images || images.length === 0) return null

  return (
    <Box sx={{ width: '100%', position: 'relative', padding: '0 48px' }}>
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
          setIsBeginning(swiper.isBeginning)
          setIsEnd(swiper.isEnd)
        }}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning)
          setIsEnd(swiper.isEnd)
        }}
      >
        {imageChunks.map((chunk, index) => (
          <SwiperSlide key={index}>
            <Grid container spacing={1}>
              {chunk.map((img, chunkImgIndex) => {
                const flatIndex = index * 10 + chunkImgIndex
                return (
                  <Grid item key={img.fileName} sx={{ width: '20%' }}>
                    <Card
                      sx={{ width: '100%', height: 70, cursor: 'pointer' }}
                      onClick={() => onImageClick && onImageClick(flatIndex)}
                    >
                      <CardMedia
                        component="img"
                        height="100%"
                        image={img.url}
                        alt={img.fileName}
                        sx={{ objectFit: 'cover' }}
                        loading="lazy"
                      />
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
          </SwiperSlide>
        ))}
      </Swiper>

      <Box
        className={`gaze-swiper-navigation icon-left ${
          isBeginning ? 'disabled' : ''
        }`}
        onClick={() => {
          if (!isBeginning && swiperRef.current) swiperRef.current.slidePrev()
        }}
      >
        <Icon icon="mdi:chevron-left" fontSize={24} />
      </Box>

      <Box
        className={`gaze-swiper-navigation icon-right ${
          isEnd ? 'disabled' : ''
        }`}
        onClick={() => {
          if (!isEnd && swiperRef.current) swiperRef.current.slideNext()
        }}
      >
        <Icon icon="mdi:chevron-right" fontSize={24} />
      </Box>
    </Box>
  )
}

export default memo(GazeImageSwiper)
